import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

/*

 # Usabilidade:

  - label: Define o label e o id do select;
  - menuOptions: Array com informações para o menu;
  - multiple: Define se o select é múltiplo ou não;
  - id: Caso o array seja um array de objetos o id é a prop que vai ser buscada para retornar o valor ao selecionar o item;
  - displayProp: É a props que vai ser buscada para retornar o valor exibido no menu de itens;
  - setValue: estado que seta o valor;
  - value: estado do valor;

  Ex: Se o menuOptions for um array simples ['bola', 'carro', 'gato'], as props id e displayProp não precisam ser utilizadas.

  Caso seja um array de objetos [{ id: 'granja', name: 'frango' }, { id: 'canio', name: 'dog' },] 
  é necessário passar id e displayProp, id será o valor retornado e displayProp o valor a ser exibido no menu de select.

*/

export const StandardSelect = ({
  disabled,
  displayProp,
  label,
  id,
  menuOptions,
  multiple,
  required,
  setValue,
  value,
  width,
}) => {
  return (
    <FormControl sx={{ width: width }}>
      <InputLabel id={`select-${label}`}>{`${label}${required ? '*' : ''}`}</InputLabel>
      <Select
        disabled={disabled}
        labelId={`select-${label}`}
        label={`${label}${required ? '*' : ''}`}
        inputProps={{ 'aria-label': label }}
        multiple={multiple}
        onChange={(e) =>
          setValue(e.target.value, label /* Label é usado caso o estado seja um objeto */)
        }
        required={required}
        value={value}
      >
        {menuOptions.map((option) => (
          <MenuItem value={option[id] ?? option}>{option[displayProp] ?? option}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
